export default {
    title: 'Current trend selection',
    subtitle: 'All trends to be evaluated in this panel are listed here',

    resetSelection: {
        tooltip: 'Delete entire Macro trend selection'
    }
}
